var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAvatar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.65 2.83a1.58 1.58 0 1 1-3.16 0 1.58 1.58 0 0 1 3.16 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.776 4.456a1.004 1.004 0 0 0 .49.518l2.859 1.38v11.502c0 .523.448.94.982.89.465-.044.806-.462.806-.928v-5.874h.278v5.912c0 .493.4.894.894.894h.035c.493 0 .894-.4.894-.894V6.354l.183-.045 1.906 4.603c.133.32.508.467.824.316.297-.142.412-.508.286-.813l-2.08-5.02a1.22 1.22 0 0 0-1.12-.742H8.126L5.84 3.848l-.908-2.191c-.126-.304-.466-.482-.776-.372a.607.607 0 0 0-.36.805l.98 2.366Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
};
export { SvgAvatar as ReactComponent };